function cov_1d6aaffyyi() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/LiveHelp.tsx";
  var hash = "eab5010c6a98514b552f9e70b62ccde13d45b4b3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/LiveHelp.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 49
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "eab5010c6a98514b552f9e70b62ccde13d45b4b3"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1d6aaffyyi = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1d6aaffyyi();
var Icon = (cov_1d6aaffyyi().s[0]++, {
  name: 'live-help',
  svg: "<path d=\"M19 1.5H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2Zm0 16h-4.83L12 19.67 9.83 17.5H5v-14h14v14Zm-8-3h2v2h-2v-2Zm1-8c1.1 0 2 .9 2 2 0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4s-4 1.79-4 4h2c0-1.1.9-2 2-2Z\" fill=\"currentColor\"/>"
});
export default Icon;